/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import { AxiosUtil } from 'src/utils';
import AdminAddUserRequest from "src/models/generated/AdminAddUserRequest";
import AdminExportUserRequest from "src/models/generated/AdminExportUserRequest";
import AdminSimpleUserResponse from "src/models/generated/AdminSimpleUserResponse";
import AdminUpdateUserRequest from "src/models/generated/AdminUpdateUserRequest";
import AdminUploadProfilePictureRequest from "src/models/generated/AdminUploadProfilePictureRequest";
import AdminUserDTO from "src/models/generated/AdminUserDTO";
import UploadMediaDTO from "src/models/generated/UploadMediaDTO";

export class AdminUserController {
    /**
     * get: /api/admin/AdminUser/getUser/${userId}
     */
    public getUser(userId: number) {
        const route = `api/admin/AdminUser/getUser/${userId}`;
        return AxiosUtil.get<AdminUserDTO>(route, AdminUserDTO.create);
    }

    /**
     * delete: /api/admin/AdminUser/deleteUser/${userId}
     */
    public deleteUser(userId: number) {
        const route = `api/admin/AdminUser/deleteUser/${userId}`;
        return AxiosUtil.delete<any>(route);
    }

    /**
     * post: /api/admin/AdminUser/listUsers
     */
    public listUsers() {
        const route = `api/admin/AdminUser/listUsers`;
        return AxiosUtil.post<AdminSimpleUserResponse[], null>(route, null, items => items.map(AdminSimpleUserResponse.create));
    }

    /**
     * post: /api/admin/AdminUser/createUser
     */
    public createUser(model: AdminAddUserRequest) {
        const route = `api/admin/AdminUser/createUser`;
        return AxiosUtil.post<any, AdminAddUserRequest>(route, model);
    }

    /**
     * post: /api/admin/AdminUser/createUser/massUpload
     */
    public createUserMassUpload(model: UploadMediaDTO) {
        const route = `api/admin/AdminUser/createUser/massUpload`;
        return AxiosUtil.postForm<any, UploadMediaDTO>(route, model);
    }

    /**
     * post: /api/admin/AdminUser/updateUser/${userId}
     */
    public updateUser(userId: number, model: AdminUpdateUserRequest) {
        const route = `api/admin/AdminUser/updateUser/${userId}`;
        return AxiosUtil.post<boolean, AdminUpdateUserRequest>(route, model);
    }

    /**
     * post: /api/admin/AdminUser/uploadProfilePictureForUser
     */
    public uploadProfilePicture(model: AdminUploadProfilePictureRequest) {
        const route = `api/admin/AdminUser/uploadProfilePictureForUser`;
        return AxiosUtil.postForm<any, AdminUploadProfilePictureRequest>(route, model);
    }

    /**
     * post: /api/admin/AdminUser/export
     */
    public exportUser(model: AdminExportUserRequest) {
        const route = `api/admin/AdminUser/export`;
        return AxiosUtil.post<any, AdminExportUserRequest>(route, model, undefined, { responseType: "blob" });
    }

    /**
     * post: /api/admin/AdminUser/test
     */
    public test() {
        const route = `api/admin/AdminUser/test`;
        return AxiosUtil.post<any, null>(route, null);
    }
}

export default new AdminUserController();
